module.exports = __webpack_public_path__ + "img/aba_darach_no.977c6394.png";